<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <div>
    <b-form-input v-model="textFilter" class="text-filter" placeholder="Search questionnaires..." size="sm" />
    <div class="survey-list">
      <zen-object-table
        :filter="textFilter"
        :columns="columns"
        :data="surveys"
        fixed
        show-empty
        empty-html="There are no questionnaire templates available, add them
          using the <a href='/import'>import page</a>."
        empty-filtered-text="No questionnaire templates match your search
          criteria."
        @row-clicked="selectSurvey"
      >
        <template slot="cell(index)" slot-scope="data">
          <b-form-radio-group v-model="mutableValue" @change="selectSurvey">
            <b-form-radio :value="data.item.id" />
          </b-form-radio-group>
        </template>
        <template slot="cell(title)" slot-scope="data">
          <a :href="data.item.previewUrl" target="_blank">
            {{ data.item.title }}
          </a>
        </template>
        <template slot="cell(weighted)" slot-scope="data">
          <i :class="generateWeightedClass(data.item.weighted)" />
        </template>
      </zen-object-table>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { BFormRadio, BFormRadioGroup, BFormInput } from 'bootstrap-vue';
import { ZenObjectTable } from 'zenComponents';

const formatDate = isoString => {
  if (!isoString) return '';
  return format(parseISO(isoString), 'MM/dd/yyyy');
};

const generateColumnStyle = (width = 100) => ({
  thStyle: { width: `${width}px` },
  tdClass: 'text-right',
});

export default {
  name: 'WizardSurveySelection',
  components: {
    BFormRadio,
    BFormRadioGroup,
    BFormInput,
    ZenObjectTable,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    surveys: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      textFilter: '',
      mutableValue: this.value,
      columns: [
        {
          key: 'index',
          label: ' ',
          ...generateColumnStyle(1),
        },
        {
          key: 'title',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          formatter: formatDate,
          ...generateColumnStyle(),
        },
        {
          key: 'updatedAt',
          label: 'Modified',
          sortable: true,
          formatter: formatDate,
          ...generateColumnStyle(),
        },
        {
          key: 'noOfQuestions',
          label: 'Questions',
          sortable: true,
          ...generateColumnStyle(),
        },
        {
          key: 'weighted',
          sortable: true,
          ...generateColumnStyle(),
        },
      ],
    };
  },
  methods: {
    selectSurvey(item) {
      this.mutableValue = Number.isInteger(item) ? item : item.id;
      this.$emit('input', this.mutableValue);
      this.$emit('update-validity', true);
    },
    generateWeightedClass(weighted) {
      return ['fa', `fa-${weighted ? 'check' : 'times'}`];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/design/colors';

.text-filter {
  margin-top: 22px;
}

.survey-list {
  margin-top: 16px;

  .object-listing-table-wrap {
    height: 460px;
  }
  .table {
    margin-bottom: 0;
  }

  .custom-control {
    display: block;
    margin: -2px 0 0 0;
    min-height: 0;
  }
}
</style>
